// extracted by mini-css-extract-plugin
export default {"container":"UserDetails_container__jsbSE","column":"UserDetails_column__9a1Eh","title":"UserDetails_title__49ogo","name":"UserDetails_name__5pPPe","value":"UserDetails_value__Okw-9"};